<template>
    <div>
        <v-card elevation="8" class="logo-card mx-auto mb-8" max-width="600">
            <v-img
                :src="require('../assets/logo.jpg')"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="250px"
            >
                <v-card-title class="text-h4 font-weight-bold">
                    MRT Kids Racing
                </v-card-title>
            </v-img>
        </v-card>
        <ImportRacers class="mb-8" />
        <Home :msg="'Benvinguts a la web de control de cursa MRT'" />
    </div>
</template>

<script>
import Home from "@/components/Home";
import ImportRacers from "@/components/ImportRacers";

export default {
    name: "HomeView",

    components: {
        Home,
        ImportRacers,
    },
};
</script>

<style scoped lang="scss">
.logo-card {
    border-radius: 16px !important;
    overflow: hidden;
}
</style>
